import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";

export default function Movements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/stock-movements", { params: { limit: 500 } }).then((r) => setItems(r.data)); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-10" data-testid="movements-page">
      <header className="mb-8">
        <div className="font-mono-ds text-[10px] tracking-widest uppercase text-zinc-500 mb-2">/ LEDGER · STOCK MOVEMENTS</div>
        <h1 className="section-title text-5xl lg:text-6xl">Movements.</h1>
      </header>

      <div className="brut-card overflow-hidden">
        <table className="brut-table">
          <thead><tr><th>When</th><th>Type</th><th>Product</th><th>SKU</th><th>Size</th><th>Qty</th><th>Reason</th><th>By</th><th>Notes</th></tr></thead>
          <tbody>
            {items.map((m) => (
              <tr key={m.id}>
                <td className="font-mono-ds text-xs whitespace-nowrap">{new Date(m.created_at).toLocaleString()}</td>
                <td>{m.type === "IN" ? <span className="brut-badge success">IN</span> : <span className="brut-badge alert">OUT</span>}</td>
                <td><Link to={`/products/${m.product_id}`} className="font-display font-bold hover:underline">{m.product_name}</Link></td>
                <td className="font-mono-ds text-xs">{m.product_sku}</td>
                <td className="font-mono-ds">{m.size}</td>
                <td className="font-mono-ds font-bold">{m.quantity}</td>
                <td className="font-mono-ds text-xs">{m.reason}</td>
                <td className="text-xs">{m.user_name}</td>
                <td className="text-xs">{m.notes}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={9} className="text-center py-8 text-zinc-500 font-mono-ds text-xs uppercase">No movements yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
